// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"b854be86","774":"b3da23f3"}[chunkId] + ".chunk.js";
};